// Subdomain → area mapping for the IHTP suite.
// When a user lands on e.g. `crm.ihavethepower.net` we treat CRM as their
// implicit choice: login redirects there directly (if allowed) and the
// selector visually promotes that card to the top.
const SUBDOMAIN_AREA = {
  crm: 'crm',
  my: 'my',
  myihtp: 'my',
  media: 'media',
  mediacenter: 'media',
};

/**
 * Inspect `window.location.hostname` and return the implied area id, or null
 * if the host doesn't map to a known area (e.g. the preview URL).
 */
export function detectSubdomainArea() {
  if (typeof window === 'undefined') return null;
  const host = (window.location.hostname || '').toLowerCase();
  // Support single-label hosts (e.g. "crm.localhost") and multi-label
  // production hosts alike. We take the first DNS label.
  const firstLabel = host.split('.')[0];
  return SUBDOMAIN_AREA[firstLabel] || null;
}
